// const BASE_URL = `http://localhost:8000`;
const BASE_URL = `https://littlechamp.onrender.com/`;

//Helo
export function getProtectedData(token) {
  return fetch(`${BASE_URL}/login/protected`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  });
}
